module.exports = __webpack_public_path__ + "static/media/x40-logo.29163289.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X40/x40-logo.svg
// module id = 445
// module chunks = 0